import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withStyles, TableRow, TableCell } from '@material-ui/core'

import DropdownMenu from '../../common/DropdownMenu'
import { ClickWrapper } from '../../../utils/helpers'

const styles = theme => ({

})

class UserList extends Component {

    render() {
        return (
            <TableRow>
                <ClickWrapper onClick={() => this.props.onSelect(this.props.item)}>
                    <TableCell>{this.props.item.provider}</TableCell>
                    <TableCell>{this.props.item.username}</TableCell>
                    <TableCell>{this.props.item.fullName}</TableCell>
                    <TableCell>{this.props.item.isActive}</TableCell>
                </ClickWrapper>
                <TableCell>
                    {this.props.actions ? <DropdownMenu type={'ACTIONS'} item={this.props.item} items={this.props.actions} />
                        : null}
                </TableCell>

            </TableRow>
        )
    }
}

const mapStateToProps = state => ({
    language: state.languageReducer.i18n.itemDetails
})

const mapDispatchToProps = dispatch => ({

})

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(UserList))